export class IAniLib {
}
IAniLib.Skeleton = null;
IAniLib.AnimationTemplet = null;
IAniLib.Templet = null;
